import { render, staticRenderFns } from "./ResAlert.vue?vue&type=template&id=26c56c6f&scoped=true"
import script from "./ResAlert.vue?vue&type=script&lang=js"
export * from "./ResAlert.vue?vue&type=script&lang=js"
import style0 from "./ResAlert.vue?vue&type=style&index=0&id=26c56c6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c56c6f",
  null
  
)

export default component.exports